import React from 'react';

const Pay = () => {
    return (
        <div className="flex justify-center  items-center p-10">
            
            <h2 className="text-4xl text-pink-600">Payment Gateway is coming soon!</h2>
            
        </div>
    );
};

export default Pay;